import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_trade_union_representatives_have_access_to_wrkrs_in_the_work'

export const dataPointDefinition = {
  retracedId: 'do_trade_union_representatives_have_access_to_wrkrs_in_the_work',
  name: 'Do trade union representatives have access to workers in the workplace?',
  description:
    "Union presence in the facility includes the existence of a company union and/or the affiliation of workers from the company to higher level unions (such as sectoral unions).\r\r\n\r\r\nAccess entails:\r\r\n-- Trade union representatives can communicate freely with their members, non-members and/or potential members, provided they do not disrupt the company's regular operations. (Employer consent may be required during times when workers are required to work, but free access should be allowed during breaks and before and after work.)\r\r\n-- Trade union representatives employed by the facility have access to workplaces (including in the facility and on the premises) so they can communicate with workers and carry out their representative functions.\r\r\n-- Access is not restricted to a particular union(s).\r\r\n-- Representatives of a union who are not employed in the facility, but whose union has members working in the facility also are granted access.\r\r\n-- When workers reside on the premises of the facility or industrial zone, suitable arrangements are made to allow onsite access after work hours even if the union does not have members employed by the facility.\r\r\n-- Access to free trade zones is provided during working hours, including so that union representatives can inform workers about the potential advantages of unionization. (Permission can be required to enter the zone, but should not be unreasonably withheld.)\r\r\n\r\r\nIf there was no union presence in the facility during the assessment period, select the answer: Not applicable. No union presence in the facility during assessment period.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'union-na',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'union-na',
    },
    {
      name: 'Not applicable. No union presence in the facility during assessment period.',
      key: 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
      slcpIndex: 3,
      slcpOptionName: 'union-na',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'foa-cb-3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12110,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
